import FormContainer from "./Components/FormContainer";

function App() {
  return (
    <div className="App">
      <FormContainer />
    </div>
  );
}

export default App;
